import { Component, Input } from '@angular/core';

@Component({
  template: require('./merge.instructions.component.html'),
  selector: 'merge-instructions'
})
export class MergeInstructionsComponent {
  @Input() merge: any;
}
